import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Button,
  CircularProgress,
  Alert,
  Dialog
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useParams } from 'react-router-dom';

// Corrigir estes caminhos:
import AdicionarPerfilForm from '../../components/Instituicoes/AdicionarPerfilForm';
import ListaPerfis from '../../components/Instituicoes/ListaPerfis';
import useAuth from '../../hooks/useAuth';
import { listarPerfis, excluirPerfil } from '../../services/perfilService';

// ⚡ IMPORTA O MODAL DE PAPÉIS
import GerirPapeisUsuario from '../../components/Usuarios/GerirPapeisUsuario';

const GerenciarPerfisPage = () => {
  const [perfis, setPerfis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const { instituicaoId } = useParams();
  const { user } = useAuth();

  // ⚡ ESTADO DO MODAL "GERIR PAPÉIS"
  const [openGerirPapeis, setOpenGerirPapeis] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  const fetchPerfis = async () => {
    try {
      const data = await listarPerfis(instituicaoId);
      console.log('Dados recebidos no GerenciarPerfisPage:', data);
      
      // Extrair apenas o array de perfis
      if (data && data.data) {
        console.log('Estrutura com paginação detectada, extraindo data.data:', data.data);
        setPerfis(data.data);
      } else if (Array.isArray(data)) {
        console.log('Estrutura de array direto detectada:', data);
        setPerfis(data);
      } else {
        console.log('Estrutura desconhecida, definindo array vazio');
        setPerfis([]);
      }
    } catch (error) {
      console.error('Erro ao carregar perfis:', error);
      setError('Erro ao carregar perfis: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPerfis();
  }, [instituicaoId]);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handlePerfilAdicionado = () => {
    fetchPerfis();
    setSuccessMessage('Perfil adicionado com sucesso!');
    handleCloseDialog();
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleExcluirPerfil = async (perfilId) => {
    try {
      await excluirPerfil(perfilId);
      setSuccessMessage('Perfil excluído com sucesso!');
      fetchPerfis();
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (error) {
      setError('Erro ao excluir perfil: ' + error.message);
    }
  };

  // ⚡ ABRIR / FECHAR MODAL DE PAPÉIS
  const handleAbrirGerirPapeis = (perfil) => {
    // o objeto vem da linha da tabela; extraímos dados do usuário
    const usuario = {
      id: perfil.Usuario?.id || perfil.usuario_id || perfil.usuarioId,
      nome: perfil.Usuario?.nome,
      username: perfil.Usuario?.username,
      email: perfil.Usuario?.email,
    };
    setUsuarioSelecionado(usuario);
    setOpenGerirPapeis(true);
  };

  const handleFecharGerirPapeis = () => {
    setOpenGerirPapeis(false);
    setUsuarioSelecionado(null);
  };

  const handleGerirPapeisSaved = async () => {
    await fetchPerfis();
    handleFecharGerirPapeis();
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h5" component="h1">
            Gerenciar Perfis
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenDialog}
          >
            Adicionar Perfil
          </Button>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {successMessage && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMessage}
          </Alert>
        )}

        {/* ⚡ Passa o callback para abrir o modal de papéis */}
        <ListaPerfis
          perfis={perfis}
          onExcluir={handleExcluirPerfil}
          instituicaoId={instituicaoId}
          onReloadPerfis={fetchPerfis}
          onGerirPapeis={handleAbrirGerirPapeis}
        />

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          fullWidth
          maxWidth="sm"
        >
          <AdicionarPerfilForm
            instituicaoId={instituicaoId}
            onSuccess={handlePerfilAdicionado}
            onCancel={handleCloseDialog}
          />
        </Dialog>

        {/* ⚡ Modal de Gerir Papéis */}
        {usuarioSelecionado && (
          <GerirPapeisUsuario
            open={openGerirPapeis}
            onClose={handleFecharGerirPapeis}
            instituicaoId={instituicaoId}
            usuario={usuarioSelecionado}
            onSaved={handleGerirPapeisSaved}
          />
        )}
      </Paper>
    </Container>
  );
};

export default GerenciarPerfisPage;